import { getOrganisation } from '@infuse/api/iam/organisation';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericOrganisation } from './generic/useGenericOrganisation';
import { getTenantOrganisation } from '@infuse/api/iam/tenant';

export const useOrganisation = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericOrganisation({
      apiFn: getTenantOrganisation,
      queryKeys: ['organisations', 'tenant'],
      onlyEnableWithParentId: true,
      initialParentId: user?.tenantId
    });
  }

  return useGenericOrganisation({
    apiFn: getOrganisation,
    queryKeys: ['organisations']
  });
};
